// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ControlMessage, ControlMessageT } from '../control/control-message';
import { ControllerInfoMessage, ControllerInfoMessageT } from '../controller-info/controller-info-message';
import { FaultMessage, FaultMessageT } from '../fault/fault-message';
import { GroupControlMessage, GroupControlMessageT } from '../group-control/group-control-message';
import { GroupSupervisoryStatusMessage, GroupSupervisoryStatusMessageT } from '../group-supervisory-status/group-supervisory-status-message';
import { BitMaskMessageContent, unionToBitMaskMessageContent, unionListToBitMaskMessageContent } from './bit-mask-message-content';
import { StatusMessage, StatusMessageT } from '../status/status-message';
import { TrafficMessage, TrafficMessageT } from '../traffic/traffic-message';


export class BitMaskMessage implements flatbuffers.IUnpackableObject<BitMaskMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BitMaskMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBitMaskMessage(bb:flatbuffers.ByteBuffer, obj?:BitMaskMessage):BitMaskMessage {
  return (obj || new BitMaskMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBitMaskMessage(bb:flatbuffers.ByteBuffer, obj?:BitMaskMessage):BitMaskMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BitMaskMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():BitMaskMessageContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : BitMaskMessageContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startBitMaskMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:BitMaskMessageContent) {
  builder.addFieldInt8(0, messageType, BitMaskMessageContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endBitMaskMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createBitMaskMessage(builder:flatbuffers.Builder, messageType:BitMaskMessageContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  BitMaskMessage.startBitMaskMessage(builder);
  BitMaskMessage.addMessageType(builder, messageType);
  BitMaskMessage.addMessage(builder, messageOffset);
  return BitMaskMessage.endBitMaskMessage(builder);
}

unpack(): BitMaskMessageT {
  return new BitMaskMessageT(
    this.messageType(),
    (() => {
      const temp = unionToBitMaskMessageContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: BitMaskMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToBitMaskMessageContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class BitMaskMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: BitMaskMessageContent = BitMaskMessageContent.NONE,
  public message: ControlMessageT|ControllerInfoMessageT|FaultMessageT|GroupControlMessageT|GroupSupervisoryStatusMessageT|StatusMessageT|TrafficMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return BitMaskMessage.createBitMaskMessage(builder,
    this.messageType,
    message
  );
}
}
